export default function InfosCarrier() {
    return (
        <>
            <div className="carrier">
                <article>
                    <h3><i class="fa-solid fa-envelope"></i></h3>
                    <ul style={{listStyle:"none"}}>
                        <li><p style={{fontSize:"14.5px"}}>b.laghmam01@gmail.com</p>
                        </li>
                        <li>
                            <p style={{fontSize:"14.5px"}}>contact@laghmam.com</p>
                        </li>
                    </ul>
                </article>
                <article>
                    <h3><i class="fa-solid fa-phone"></i></h3>
                    <p>+212 623948044</p>
                </article>
                <article>
                    <h3><i class="fa-solid fa-location-dot"></i></h3>
                    <p>Berkane/Maroc</p>
                </article>
            </div>
        </>
    )
}
